export const computeInitialDocumentLink = ({
  statementLink,
  dateFrom,
  dateTo,
}: {
  statementLink?: string;
  dateFrom?: Date;
  dateTo?: Date;
}) => {
  if (!statementLink) return '';
  if (dateFrom || dateTo) return '';
  return statementLink;
};
